// extracted by mini-css-extract-plugin
module.exports = {"productName":"_11_WM","bottomGutter":"nnSM2","horizontalTextAlign":"_2eE5B","verticalTextAlign":"_283b_"};